module.exports = __webpack_public_path__ + "static/media/Netflix_Logo_RGB.8562b656.png";